import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=050deb6a&scoped=true&"
import script from "./InvoiceHistory.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050deb6a",
  null
  
)

export default component.exports